/// <reference path="../types/types.d.ts" />

import { Injectable } from "@angular/core";
import { LoggerService } from "@app/logger/logger.service";
import { environment } from "@env/environment";



const log = new LoggerService('ORGANIZATION SERVICE');


@Injectable({ providedIn: "root" })
export class OrganizationsService {


  /**
   * @description Busca un usuario con sus organizaciones y sus roles que tiene asignados.
   */
  public async findUserOranizations() {
    const userid = localStorage.getItem('userId');
    const idToken = localStorage.getItem('idToken');
    const response = await fetch(`${environment.EPIONE_API}/epione-core-api/users/roles/${userid}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
    });
    const apiResponse: Utils.ApiResponse<Entities.Custom.UserWithOrgsAndRoles> = await response.json();
    log.debug('[findUserOranizations] API Response: ', apiResponse);
    return apiResponse;
  }


  /**
   * @description Edita una organización existente.
   * @param orgData Los datos de la organización a modificar
   * @returns Entities.Organization.OrganizationData[]
   */
  public async editOrganization(orgData: Entities.Organization.OrganizationData) {
    const idToken = localStorage.getItem('idToken');
    const fetchResponse = await fetch(`${environment.EPIONE_API}/epione-core-api/organizations`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(orgData)
    });
    const apiResponse: Utils.ApiResponse<Entities.Organization.OrganizationData> = await fetchResponse.json();
    log.debug('[editOrganization] API Response: ', apiResponse);
    return apiResponse;

  }


  
  /**
   * @description Edita una organización existente.
   * @param orgData Los datos de la organización a modificar
   * @returns Entities.Organization.OrganizationData[]
   */
   public async createOrganization(orgData: Entities.Organization.OrganizationData) {
    const idToken = localStorage.getItem('idToken');
    const fetchResponse = await fetch(`${environment.EPIONE_API}/epione-core-api/organizations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(orgData)
    });
    const apiResponse: Utils.ApiResponse<Entities.Organization.OrganizationData> = await fetchResponse.json();
    log.debug('[editOrganization] API Response: ', apiResponse);
    return apiResponse;

  }


  /**
   * @description Busca organizaciones con un query personalizado.
   * @param orgDataQuery Los datos de la organización u organizaciones a buscar
   * @returns Entities.Organization.OrganizationData[]
   */
   public async findOrganizations(orgDataQuery: Entities.Organization.OrganizationData) {
    const idToken = localStorage.getItem('idToken');
    const fetchResponse = await fetch(`${environment.EPIONE_API}/epione-core-api/organizations/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(orgDataQuery)
    });
    const apiResponse: Utils.ApiResponse<Entities.Organization.OrganizationData> = await fetchResponse.json();
    log.debug('[editOrganization] API Response: ', apiResponse);
    return apiResponse;

  }

}